import $ from 'jquery';

var isSafari = navigator.userAgent.indexOf( 'Safari' ) > -1;

if ( isSafari ) {

  function makeEqualHeight() {

    // Make .equal-height elements equal height in safari
    var $equalHeightTargets = $( '.equal-height-target' );
    var offsetHeights = {};

    $equalHeightTargets.css( 'height', 'auto' );

    // First we store the max heights in offsetHeights per offset top
    $.each( $equalHeightTargets, function ( i, target ) {

      var $target = $( target );
      var height = $target.outerHeight();
      var offset = Math.ceil( $target.offset().top );

      if ( typeof offsetHeights[ offset ] === 'undefined' ) {

        offsetHeights[ offset ] = 0;

      }

      offsetHeights[ offset ] = Math.max( offsetHeights[ offset ], height );

    });

    // Then we set the element heights according to the stored heights
    $.each( $equalHeightTargets, function ( i, target ) {

      var $target = $( target );
      var offset = Math.ceil( $target.offset().top );
      var height = typeof offsetHeights[ offset ] !== 'undefined' ? offsetHeights[ offset ] : $target.outerHeight();

      $target.css( 'height', height + 'px' );

    });

  }

  makeEqualHeight();

  $( window ).on( 'resize', makeEqualHeight );

  $( '.tab-switch' ).on( 'change', makeEqualHeight );

}
